var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrimaryLarge = function SvgPrimaryLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 256 256"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0A3A6B",
    d: "m132.831 2.735 36.255 47.68a191.4 191.4 0 0 0 36.498 36.499l47.681 36.255c3.193 2.427 3.193 7.235 0 9.662l-47.681 36.255a191.5 191.5 0 0 0-36.498 36.498l-36.255 47.681c-2.427 3.193-7.235 3.193-9.662 0l-36.255-47.681a191.5 191.5 0 0 0-36.498-36.498l-47.68-36.255c-3.194-2.427-3.194-7.235 0-9.662l47.68-36.255a191.4 191.4 0 0 0 36.498-36.498l36.255-47.68c2.427-3.194 7.235-3.194 9.662 0"
  })));
};
export default SvgPrimaryLarge;